<h3 class="section-title">Pricing & Costs</h3>
<div class="grid" [formGroup]="lotForm">
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="col-3">
        <span matPrefix class="cb-margin-right-2x">$&nbsp;</span>
        <mat-label>Land Price</mat-label>
        <input
            matInput
            type="text"
            inputmode="decimal"
            formControlName="PriceLand"
        >
        @if (hasError('PriceLand')) {
            <mat-error>{{ getErrorMessage('PriceLand', 'Land Price') }}</mat-error>
        }
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="col-3">
        <span matPrefix class="cb-margin-right-2x">$&nbsp;</span>
        <mat-label>Sell Price</mat-label>
        <input
            matInput
            type="text"
            inputmode="decimal"
            formControlName="PriceSell"
        >
        @if (hasError('PriceSell')) {
            <mat-error>{{ getErrorMessage('PriceSell', 'Sell Price') }}</mat-error>
        }
    </mat-form-field>
</div>
